<template>
  <div class="main">
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;400&display=swap" rel="stylesheet">
    <div v-if="name === ''" class="inputs">
      <center>
        Zadaj svoje meno:
        <br>
        <input type="text" id="name">
        <br>
        <input type="submit" value="Začni hru" @click="setName" class="submit">
      </center>
    </div>
    <div v-else>
      <Video v-if="index !== '0'" :filename="filename" :clip="clips[index]" @to="step" />
      <div v-else>
        Gratulujeme k úspešnému ukončeniu hry. 
        <p> Tvoj počet bodov: {{ score }} </p>
        <p> Pozri sa, ako si počínali ostatní: </p>
        <p> V krčme sa pokúsilo popíjajúcemu razantne vysvetliť situáciu {{ razantne }} z {{ celkovyPocet }} ľudí. </p>
        <p> V reštaurácii obvinilo Kel z vraždy kelu {{ obvinilo }} z {{ celkovyPocet }} ľudí. </p>
        <p> Vo vypočúvacej miestnosti sa zlým policajtom rozhodlo byť {{ zly }} z {{ celkovyPocet }} ľudí. </p>
        <p> V lese potrestalo malý kelíček {{ potrestalo }} z {{ celkovyPocet }} ľudí. </p>
      </div>
    </div>
  </div>
</template>
<script src="https://www.gstatic.com/firebasejs/7.15.2/firebase-app.js"></script>
<script src="https://www.gstatic.com/firebasejs/7.15.2/firebase-firestore.js"></script>
<script>
import Video from "@/components/Video.vue";
const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");
firebase.initializeApp({
  apiKey: 'AIzaSyAnvMs_dwm8EY7Fum1laiOU4wz79BSYrKI',
  authDomain: 'project-493369040392',
  projectId: 'minisustredka-video'
});

var db = firebase.firestore();


export default {
  name: "Home",
  components: {
    Video
  },
  data() {
    return {
      clips: {
        "00": {
          choices: [],
          default: {
            to: "01",
            score: 0
          }
        },
        "01": { 
          choices: [],
          default: {
            to: "02",
            score: 0
          }
        },
        "02": {
          choices: [
            {
              text: "Zdvihnúť hovor",
              to: "03a",
              score: 1
            },
            {
              text: "Nechať hovor skúsenejším",
              to: "03b",
              score: 0
            }
          ],
          default: {
            to: "03b",
            score: 0
          }
        },
        "03a": { 
          choices: [],
          default: {
            to: "04",
            score: 0
          }
        },
        "03b": { 
          choices: [],
          default: {
            to: "04",
            score: 0
          }
        },
        "04": { 
          choices: [
            {
              text: "Čaj",
              to: "05a",
              score: 2
            },
            {
              text: "Pivo",
              to: "05b",
              score: 1
            },
            {
              text: "Vodka",
              to: "05c",
              score: 0
            }
          ],
          default: {
            to: "05a",
            score: 0
          },
          time: 12000
        },
        "05a": { 
          choices: [],
          default: {
            to: "06",
            score: 0
          }
        },
        "05b": { 
          choices: [],
          default: {
            to: "06",
            score: 0
          }
        },
        "05c": { 
          choices: [],
          default: {
            to: "06",
            score: 0
          }
        },
        "06": {
          choices: [
            {
              text: "Jemne vysvetliť, kto je tu policajt",
              to: "07a",
              score: 0
            },
            {
              text: "Rázne vysvetliť, kto je tu policajt",
              to: "07b",
              score: 0
            }
          ],
          default: {
            to: "07b",
            score: 0
          }
        },
        "07a": { 
          choices: [],
          default: {
            to: "08",
            score: 0
          }
        },
        "07b": { 
          choices: [],
          default: {
            to: "08",
            score: 0
          }
        },
        "08": {
          choices: [
            {
              text: "S nadp. Milotovou",
              to: "09a",
              score: 0
            },
            {
              text: "S detektívom Novákom",
              to: "09b",
              score: 0
            }
          ],
          default: {
            to: "09a",
            score: 0
          },
          time: 10000
        },
        "09a": { 
          choices: [],
          default: {
            to: "10a",
            score: 0
          }
        },
        "09b": { 
          choices: [],
          default: {
            to: "10b",
            score: 0
          }
        },
        "10a": { 
          choices: [],
          default: {
            to: "11",
            score: 0
          }
        },
        "10b": { 
          choices: [],
          default: {
            to: "11",
            score: 0
          }
        },
        "11": {
          choices: [
            {
              text: "Zájdeme na čaj?",
              to: "12a",
              score: 1
            },
            {
              text: "Pôjdeme sa najesť?",
              to: "12b",
              score: 0
            }
          ],
          default: {
            to: "12a",
            score: 0
          },
          time: 6000
        },
        "12a": { 
          choices: [],
          default: {
            to: "13",
            score: 0
          }
        },
        "12b": { 
          choices: [],
          default: {
            to: "13",
            score: 0
          }
        },
        "13": {
          choices: [
            {
              text: "Heej, jasné, všetko v pohode",
              to: "14a",
              score: 4
            },
            {
              text: "To ty si zabila ten kel!",
              to: "14b",
              score: 2
            }
          ],
          default: {
            to: "14b",
            score: 0
          },
          time: 12000
        },
        "14a": { 
          choices: [],
          default: {
            to: "15a",
            score: 0
          }
        },
        "14b": { 
          choices: [],
          default: {
            to: "15b",
            score: 0
          }
        },
        "15a": {
          choices: [
            {
              text: "Čožee?!",
              to: "15aa",
              score: 0
            },
            {
              text: "Asi som to vedel...",
              to: "15ab",
              score: 0
            }
          ],
          default: {
            to: "15aa",
            score: 0
          },
          time: 7000
        },
        "15aa": { 
          choices: [],
          default: {
            to: "15c",
            score: 0
          }
        },
        "15ab": { 
          choices: [],
          default: {
            to: "15c",
            score: 0
          }
        },
        "15b": { 
          choices: [],
          default: {
            to: "15c",
            score: 0
          }
        },
        "15c": { 
          choices: [],
          default: {
            to: "16",
            score: 0
          }
        },
        "16": { 
          choices: [],
          default: {
            to: "17",
            score: 0
          }
        },
        "17": {
          choices: [
            {
              text: "Byť zlým policajtom",
              to: "18a",
              score: 5
            },
            {
              text: "Byť dobrým policajtom",
              to: "18b",
              score: 10
            }
          ],
          default: {
            to: "18a",
            score: 0
          }
        },
        "18a": { 
          choices: [],
          default: {
            to: "19a",
            score: 0
          }
        },
        "18b": { 
          choices: [],
          default: {
            to: "19b",
            score: 0
          }
        },
        "19a": {
          choices: [
            {
              text: "Potrestať za to, že mi chce zobrať Kel",
              to: "20a",
              score: 5
            },
            {
              text: "Zachrániť ho",
              to: "20b",
              score: 10
            }
          ],
          default: {
            to: "20a",
            score: 0
          },
          time: 10000
        },
        "19b": {
          choices: [
            {
              text: "Potrestať za to, že mi chce zobrať Kel",
              to: "20a",
              score: 5
            },
            {
              text: "Zachrániť ho",
              to: "20c",
              score: 10
            }
          ],
          default: {
            to: "20a",
            score: 0
          },
          time: 10000
        },
        "20a": {
          choices: [],
          default: {
            to: "21a",
            score: 0
          },
        },
        "20b": {
          choices: [],
          default: {
            to: "21b",
            score: 0
          },
        },
        "20c": {
          choices: [],
          default: {
            to: "21c",
            score: 0
          },
        },
        "21a": {
          choices: [],
          default: {
            to: "0",
            score: 0
          },
        },
        "21b": {
          choices: [],
          default: {
            to: "0",
            score: 0
          },
        },
        "21c": {
          choices: [],
          default: {
            to: "0",
            score: 0
          },
        }
      },
      index: "00",
      score: 0,
      route: "00",
      name: '',
      scores: []
    };
  },
  methods: {
    step(to, score) {
      this.index = to;
      this.route += ' ' + to;
      this.score += score;
      if (to === '0') {
        db.collection("scores").add({
          name: this.name,
          score: this.score,
          route: this.route,
          time: new Date
        }).then(() => {
          db.collection('scores').get().then(documents => {
            documents.forEach(document => {
              this.scores.push(document.data())
            })
          })
        })
      }
    },
    setName() {
      this.name = document.getElementById('name').value
    }
  },
  computed: {
    filename() {
      return `${this.index}.mp4`;
    },
    razantne() {
      return this.scores.filter(score => {
        return score.route && score.route.includes(" 07b ")
      }).length
    },
    obvinilo() {
      return this.scores.filter(score => {
        return score.route && score.route.includes(" 14b ")
      }).length
    },
    zly() {
      return this.scores.filter(score => {
        return score.route && score.route.includes(" 18a ")
      }).length
    },
    potrestalo() {
      return this.scores.filter(score => {
        return score.route && score.route.includes(" 21a ")
      }).length
    },
    celkovyPocet() {
      return this.scores.filter(score => {
        return !!score.route
      }).length
    }
  }
};
</script>

<style scoped lang="scss">
  .main {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    color: white;
    font-family: 'Roboto', sans-serif;
    font-size: 3em;
  }

  .inputs{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  #name {
    background-color: black;
    color: white;
    border-color: white;
    border: 3px solid;
    font-size: 0.7em;
    width: 70%;
    padding: 8px;
    margin-top: 20px;
  }

  .submit {
    margin-top: 30px;
    background-color: black;
    color: white;
    border-color: white;
    font-size: 0.7em;
    border: 2px solid;
    padding: 5px;
  }

  .submit:hover {
    background-color: white;
    color: black;
    border-color: white;
    cursor: pointer;
  }
</style>
